import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { FilterOperatorMenu } from 'admin/src/components/ui/DataGrid/filters/FilterOperatorMenu';
import type { FilterOperator } from 'admin/src/components/ui/DataGrid/filters/operators';
import type { FilterableColumn } from 'admin/src/components/ui/DataGrid/filters/types';
import { Button } from 'shared/src/components/ui/new/Button';

type PanelOperatorRowProps = {
  column: FilterableColumn;
  operator: FilterOperator;
  values: string[];
  fallbackSecondValue?: string;
  onChange: (operator: FilterOperator, values: string[]) => void;
};

/**
 * Lets a not-yet-created filter reach the range operators, which would otherwise only be
 * available from a chip that does not exist yet.
 */
export function PanelOperatorRow({ column, operator, values, fallbackSecondValue, onChange }: PanelOperatorRowProps) {
  return (
    <div className="flex items-center border-b px-1.5 py-1">
      <FilterOperatorMenu column={column} operator={operator} values={values} fallbackSecondValue={fallbackSecondValue} onChange={onChange}>
        <Button variant="ghost" size="sm" className="h-6 gap-1 px-1.5 text-xs font-normal text-muted-foreground">
          {operator}
          <ChevronDownIcon className="size-3" />
        </Button>
      </FilterOperatorMenu>
    </div>
  );
}
